import {
  Component,
  Input,
  Output,
  OnInit,
  OnChanges,
  EventEmitter
} from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import {
  BluePrintTicket,
  Ticket,
  User,
  Division,
  APIResponse,
  TicketCount,
  ChangeLabelLogData,
  ChangeDivisionLogData,
  AssignTicketLogData
} from '../../_shared/models';
import {
  UserService,
  TicketService,
  AuthenticationService,
  LoadingService
} from '../../_shared/services';
import { Granule } from '../../config';

@Component({
  selector: 'app-ticket-action',
  templateUrl: './ticket-action.component.html',
  styleUrls: [
    '../../../assets/css/core-navbar.css',
    '../_css-ticket/ticket-content.css',
    './ticket-action.component.css',
    '../_css-ticket/ticket-content-mobile-responsive-action.css'
  ]
})
export class TicketActionComponent implements OnInit, OnChanges {
  @Input() private selectedTicket: Ticket;
  @Input() private isActionShown: boolean;
  @Output() refetch = new EventEmitter<BluePrintTicket>();
  @Output() changeShown = new EventEmitter<string>();
  private storageProfileUrl = this.granule.CMS_ROUTE_STORAGE_USER;
  private testdropdown: any;
  private divisions: Division[];
  private user: User;
  private users: User[];
  private ticketCount: TicketCount;
  private toggleDropdown = new Array<boolean>(3);
  /*
  [0] = Division
  [1] = Label
  [2] = Staffs
   */
  private selectedDivision: string;
  private selectedLabel: string;
  private selectedOfficer = new User();

  constructor(
    private granule: Granule,
    private userService: UserService,
    private ticketService: TicketService,
    private authenticationService: AuthenticationService,
    private loadingService: LoadingService,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.user = this.authenticationService.getUserInfo();
    this.initAdmins();
    this.initDivision();
    this.initToggleDropdown();
  }

  ngOnChanges(changes: any) {
    this.initToggleDropdown();
    if (changes['selectedTicket']) {
      // bind with label dropdown
      if (this.selectedTicket.label == 0) {
        this.selectedLabel = 'Select Label';
      } else if (this.selectedTicket.label > 0) {
        this.changeSelectedLabel(this.selectedTicket.label);
      }

      // bind with assign dropdown
      if (this.selectedTicket.taken_by == null) {
        this.selectedOfficer.fullname = 'Select Member';
      } else if (this.selectedTicket.taken_by != null) {
        this.selectedOfficer = this.selectedTicket.officer_detail;
      }

      // bind with division dropdown
      if (this.selectedTicket.division == null) {
        this.selectedDivision = 'Select Division';
      } else if (this.selectedTicket.division != null) {
        this.selectedDivision = this.selectedTicket.division_detail.name;
      }

      // get ticket count for the client
      if (this.selectedTicket.cust_detail) {
        this.countTickets();
      }
    }
  }

  initToggleDropdown() {
    // init the dropdown for the first time, and also closes the dropdown if called
    for (let i = 0; i < this.toggleDropdown.length; i++) {
      this.toggleDropdown[i] = false;
    }
  }

  initDivision() {
    this.userService.getDivision().subscribe((res: APIResponse<any, any>) => {
      this.divisions = res.data;
    });
  }

  back() {
    this.changeShown.emit('BackToDetail');
  }

  countTickets() {
    // selectedTicket.cust_detail.tickets.open
    let payload = JSON.stringify({
      user_id: this.selectedTicket.cust_detail._id,
      user_role: 'Client'
    });
    this.userService.getCountedTickets(payload).subscribe(res => {
      this.ticketCount = res.data;
    });
  }

  dropdownControl(value: number) {
    for (let i in this.toggleDropdown) {
      let parsedIndex = parseInt(i);
      if (parseInt(i) === value) {
        // if the array number match with value from function, reverse the bool value to toggle
        this.toggleDropdown[parseInt(i)] = !this.toggleDropdown[parseInt(i)];
      } else {
        // other than that, set to false to close dropdown
        this.toggleDropdown[parseInt(i)] = false;
      }
    }
  }

  initAdmins() {
    this.userService.getUsers('distribution').subscribe(res => {
      this.users = res.data;
    });
  }

  assignTo(officer: User) {
    // show modal notif error here
    if (this.selectedTicket.label > 0) {
      this.selectedOfficer = officer;
      let assign_data: AssignTicketLogData = {
        Log: {
          assigned_to: this.selectedOfficer._id,
          assigned_by: this.user._id
        },
        status: 'Open',
        ticket_id: this.selectedTicket.ticket_id
      };
      this.ticketService.setLabelAndAssign(assign_data).subscribe(res => {
        console.log(res);
        this.selectedTicket.status = res.data.status;

        if (res.data.label != 0 && res.data.taken_by != null) {
          this.refetch.emit(this.selectedTicket);
        }
      });
    }
  }

  selectDivision(div: Division) {
    console.log(div);
    const ticketDivision: ChangeDivisionLogData = {
      ticket_id: this.selectedTicket.ticket_id,
      type: 'Technical',
      Log: {
        set_division_by: this.user._id,
        division: div._id
      }
    };
    this.ticketService.setTicketDivision(ticketDivision).subscribe(
      res => {},
      x => {},
      () => {
        this.selectedTicket.division = div.id;
        this.selectedDivision = div.name;
        this.refetch.emit(this.selectedTicket);
      }
    );
  }

  changeSelectedLabel(label: number) {
    this.selectedLabel = 'Label ' + label.toString();
  }

  selectLabel(label: number) {
    const ticketLabel: ChangeLabelLogData = {
      ticket_id: this.selectedTicket.ticket_id,
      Log: {
        labelled_by: this.user._id,
        label_value: label
      },
      status: 'Open'
    };
    console.log(ticketLabel);
    this.ticketService.setLabelAndAssign(ticketLabel).subscribe(
      res => {},
      x => {},
      () => {
        this.changeSelectedLabel(label);
        this.selectedTicket.label = label;
      }
    );
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/ticket/ticket-action/ticket-action.component.ts